{
    "PromptDeletereport": "Weet je zeker dat je wilt verwijderen?",
    "PromptDeletereports": "Weet u zeker dat u de geselecteerde rapporten definitief wilt verwijderen?",
    "PromptEmptyrecyclebin": "Weet u zeker dat u alle rapporten in de prullenbak permanent wilt verwijderen?",
    "PromptRemovereport": "Weet u zeker dat u dit rapport wilt verwijderen?",
    "PromptReportswillbedeletedpermanently": "Rapporten worden permanent verwijderd en kunnen niet worden hersteld.",
    "AreYouSureDelete": "Weet je zeker dat je wilt verwijderen?",
    "AreYouSureRemove": "Weet u zeker dat u dit rapport wilt verwijderen?",
    "LanguagePrompt_PromptConfirm": "Bevestigen",
    "LanguagePrompt_PromptCancel": "Annuleren",
    "NAME": "LanguagePrompt"
}